import SalesByArticleHistoryManager from './SalesByArticleHistoryManager'

export default SalesByArticleHistoryManager
